import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Home, Grid3x3, ShoppingBag, User } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useCustomerAuth } from '../context/CustomerAuthContext';

const BottomNav = () => {
  const { count, setOpen } = useCart();
  const { token } = useCustomerAuth();
  const location = useLocation();

  // Hide on admin pages
  if (location.pathname.startsWith('/admin')) return null;

  const items = [
    { to: '/', label: 'Home', icon: Home, exact: true },
    { to: '/#categories', label: 'Shop', icon: Grid3x3, hash: true },
    { to: 'cart', label: 'Cart', icon: ShoppingBag, action: true },
    { to: token ? '/my-orders' : '/login', label: token ? 'Orders' : 'Sign in', icon: User },
  ];

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-xl border-t border-neutral-200 safe-bottom">
      <div className="max-w-md mx-auto flex items-center justify-around px-2 py-1.5">
        {items.map((item) => {
          const Icon = item.icon;
          const isActive =
            item.exact ? location.pathname === item.to :
            item.hash ? location.pathname === '/' :
            item.action ? false :
            location.pathname.startsWith(item.to);

          const baseCls = `flex flex-col items-center gap-0.5 px-3 py-2 min-w-[60px] transition-colors ${
            isActive ? 'text-[#0078D4]' : 'text-neutral-500 hover:text-[#0F172A]'
          }`;

          if (item.action) {
            return (
              <button key={item.label} onClick={() => setOpen(true)} className={baseCls}>
                <div className="relative">
                  <Icon className="w-5 h-5" strokeWidth={2.2} />
                  {count > 0 && (
                    <span className="absolute -top-1.5 -right-2 w-4 h-4 rounded-full bg-[#0078D4] text-white text-[9px] font-bold flex items-center justify-center">
                      {count}
                    </span>
                  )}
                </div>
                <span className="text-[10px] font-medium">{item.label}</span>
              </button>
            );
          }

          return (
            <NavLink key={item.label} to={item.to} className={baseCls}>
              <Icon className="w-5 h-5" strokeWidth={2.2} />
              <span className="text-[10px] font-medium">{item.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
